import styled from 'styled-components';

export const DisplayNoneImprimir = styled.div`
  display: none;
`;